var _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.75,
    stroke: "#707C97",
    strokeOpacity: 0.5,
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63672 13.6367C8.45684 15.2574 10.1031 16.364 12.0004 16.364C13.8976 16.364 15.5439 15.2574 16.364 13.6367",
    stroke: "#707C97",
    strokeOpacity: 0.5,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.72763,
    cy: 8.72763,
    r: 1.09091,
    fill: "#707C97",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2745,
    cy: 8.72763,
    r: 1.09091,
    fill: "#707C97",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/SmileIcon.20710cd02e0393e6c577d4e2e505f144.svg";
export { ForwardRef as ReactComponent };